import { InjectionToken } from '@angular/core';
import { ITelemetryPublisher } from './ITelemetryPublisher';

export const TELEMETRY_PUBLISHER = new InjectionToken<ITelemetryPublisher[]>(
	'TelemetryPublisher',
);
